<template>
  <layout>
    <template slot="drawer">
      <v-form ref="searchform" v-if="ctx" @submit.prevent="search()">
        <v-row no-gutters class="pt-2 pr-1">
          <v-col cols="12">
            <v-subheader light class="pa-0 mt-5 mb-0 mx-0 form-subheader"
            >Dates de réservation
            </v-subheader
            >
            <v-divider></v-divider>
          </v-col>
          <v-col cols="6" class="pr-1 mb-3">
            <smart-picker
                v-model="ctx.startDateAct"
                :stopDate="ctx.stopDateAct"
                :inputOpts="{
                label: $t('start'),
                clearable: true,
                placeholder: ' ',
              }"
            ></smart-picker>
          </v-col>
          <v-col cols="6" class="pr-1">
            <smart-picker
                v-model="ctx.stopDateAct"
                :startDate="ctx.startDateAct"
                :inputOpts="{
                label: $t('end'),
                clearable: true,
                placeholder: ' ',
              }"
            ></smart-picker>
          </v-col>

        </v-row>

        <smart-btn type="submit" :loading="loading" block primary
        >Rechercher
        </smart-btn
        >
        <smart-btn
            block
            tertiary
            @click.native="
            clearSearchform();

          "
        >Réinitialiser la recherche
        </smart-btn
        >
      </v-form>
    </template>
    <template slot="content">
      <div class="grid ">
        <v-row v-if="data.total.length > 0">
          <v-col class="col-xs-0 col-sm-0 col-md-3 "></v-col>
          <v-col class="col-sm-12 col-md-6 ">
            <div class="d-flex align-center">
              <v-subheader class=" title mr-2">Total</v-subheader>
              <v-chip x-small outlined color="green">
                n-1
              </v-chip>
            </div>
            <v-data-table class="tbl"
                          :headers="headers"
                          :items="data.total"
                          hide-default-footer>
              <template #header.actions="{item}">
                <div>
                  <v-icon small @click="copyTotal" class="pl-2">mdi-clipboard-text-outline</v-icon>
                </div>
              </template>
              <template #body="{items}">
                <tbody>
                <tr v-for="(item, idx) in items" :key="idx">
                  <td  :class="idx == items.length -1 ? 'font-weight-bold':''">
                    {{ item.regionName }}
                  </td>
                  <td class="text-right">
                    <span class="mr-1  font-weight-regular">{{ item.nbActiveAgencies.act }}</span>
                    <span class="caption"
                          :class="item.nbActiveAgencies.act < item.nbActiveAgencies.old ? 'red--text':'green--text'">
                    {{ item.nbActiveAgencies.old }}
                  </span>
                  </td>
                  <td class="text-right">
                    <span class="mr-1  font-weight-regular">{{ item.nbAgencies.act }}</span>
                    <span class="caption"
                          :class="item.nbAgencies.act < item.nbAgencies.old ? 'red--text':'green--text'">
                    {{ item.nbAgencies.old }}
                  </span>
                  </td>
                  <td class="text-right">
                    <span class="mr-1  font-weight-regular">{{ item.nbAgents.act }}</span>
                    <span class="caption" :class="item.nbAgents.act < item.nbAgents.old ? 'red--text':'green--text'">
                    {{ item.nbAgents.old }}
                  </span>
                  </td>
                  <td class="text-right">
                    <span class="mr-1  font-weight-regular">{{ item.nbBookings.act }}</span>
                    <span class="caption"
                          :class="item.nbBookings.act < item.nbBookings.old ? 'red--text':'green--text'">
                    {{ item.nbBookings.old }}
                  </span>
                  </td>
                  <td class="text-right">
                    <span class="mr-1  font-weight-regular">{{ item.totalRevenue.act | currency("EUR") }}</span>
                    <span class="caption"
                          :class="item.totalRevenue.act < item.totalRevenue.old ? 'red--text':'green--text'">
                    {{ item.totalRevenue.old | currency("EUR") }}
                  </span>
                  </td>

                </tr>
                </tbody>
              </template>

            </v-data-table>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="col-xs-0 col-sm-0 col-md-3 "></v-col>
          <v-col class="col-sm-12 col-md-6 ">
            <div class="d-flex align-center">
              <v-subheader class=" title mr-2">Avec Vols</v-subheader>
              <v-chip x-small outlined color="green">
                n-1
              </v-chip>
            </div>
            <v-data-table class="tbl" v-if="data.withFlights != null"
                          :headers="headers"
                          :items="data.withFlights"
                          hide-default-footer>
              <template #header.actions="{item}">
                <div>
                  <v-icon small @click="copyWithFlight" class="pl-2">mdi-clipboard-text-outline</v-icon>
                </div>
              </template>
              <template #body="{items}">
                <tbody>
                <tr v-for="(item, idx) in items" :key="idx">
                  <td :class="idx == items.length -1 ? 'font-weight-bold':''">
                    {{ item.regionName }}
                  </td>
                  <td class="text-right">
                    <span class="mr-1  font-weight-regular">{{ item.nbActiveAgencies.act }}</span>
                    <span class="caption"
                          :class="item.nbActiveAgencies.act < item.nbActiveAgencies.old ? 'red--text':'green--text'">
                    {{ item.nbActiveAgencies.old }}
                  </span>
                  </td>
                  <td class="text-right">
                    <span class="mr-1  font-weight-regular">{{ item.nbAgencies.act }}</span>
                    <span class="caption"
                          :class="item.nbAgencies.act < item.nbAgencies.old ? 'red--text':'green--text'">
                    {{ item.nbAgencies.old }}
                  </span>
                  </td>
                  <td class="text-right">
                    <span class="mr-1  font-weight-regular">{{ item.nbAgents.act }}</span>
                    <span class="caption" :class="item.nbAgents.act < item.nbAgents.old ? 'red--text':'green--text'">
                    {{ item.nbAgents.old }}
                  </span>
                  </td>
                  <td class="text-right">
                    <span class="mr-1  font-weight-regular">{{ item.nbBookings.act }}</span>
                    <span class="caption"
                          :class="item.nbBookings.act < item.nbBookings.old ? 'red--text':'green--text'">
                    {{ item.nbBookings.old }}
                  </span>
                  </td>
                  <td class="text-right">
                    <span class="mr-1  font-weight-regular">{{ item.totalRevenue.act | currency("EUR") }}</span>
                    <span class="caption"
                          :class="item.totalRevenue.act < item.totalRevenue.old ? 'red--text':'green--text'">
                    {{ item.totalRevenue.old | currency("EUR") }}
                  </span>
                  </td>

                </tr>
                </tbody>
              </template>

            </v-data-table>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="col-xs-0 col-sm-0 col-md-3 "></v-col>
          <v-col class="col-sm-12 col-md-6 ">
            <div class="d-flex align-center">
              <v-subheader class=" title mr-2">Sans Vols</v-subheader>
              <v-chip x-small outlined color="green">
                n-1
              </v-chip>
            </div>
            <v-data-table class="tbl" v-if="data.noFlights != null"
                          :headers="headers"
                          :items="data.noFlights"
                          hide-default-footer
            >
              <template #header.actions="{item}">
                <div>
                  <v-icon small @click="copyNoFlight" class="pl-2">mdi-clipboard-text-outline</v-icon>
                </div>
              </template>
              <template #body="{items}">
                <tbody>
                <tr v-for="(item, idx) in items" :key="idx" class="">
                  <td :class="idx == items.length -1 ? 'font-weight-bold':''">
                    {{ item.regionName }}
                  </td>
                  <td class="text-right">
                    <span class="mr-1  font-weight-regular">{{ item.nbActiveAgencies.act }}</span>
                    <span class="caption"
                          :class="item.nbActiveAgencies.act < item.nbActiveAgencies.old ? 'red--text':'green--text'">
                    {{ item.nbActiveAgencies.old }}
                  </span>
                  </td>
                  <td class="text-right">
                    <span class="mr-1  font-weight-regular">{{ item.nbAgencies.act }}</span>
                    <span class="caption"
                          :class="item.nbAgencies.act < item.nbAgencies.old ? 'red--text':'green--text'">
                    {{ item.nbAgencies.old }}
                  </span>
                  </td>
                  <td class="text-right">
                    <span class="mr-1  font-weight-regular">{{ item.nbAgents.act }}</span>
                    <span class="caption" :class="item.nbAgents.act < item.nbAgents.old ? 'red--text':'green--text'">
                    {{ item.nbAgents.old }}
                  </span>
                  </td>
                  <td class="text-right">
                    <span class="mr-1  font-weight-regular">{{ item.nbBookings.act }}</span>
                    <span class="caption"
                          :class="item.nbBookings.act < item.nbBookings.old ? 'red--text':'green--text'">
                    {{ item.nbBookings.old }}
                  </span>
                  </td>
                  <td class="text-right">
                    <span class="mr-1  font-weight-regular">{{ item.totalRevenue.act | currency("EUR") }}</span>
                    <span class="caption"
                          :class="item.totalRevenue.act < item.totalRevenue.old ? 'red--text':'green--text'">
                    {{ item.totalRevenue.old | currency("EUR") }}
                  </span>
                  </td>
                </tr>
                </tbody>
              </template>

            </v-data-table>
          </v-col>
        </v-row>
      </div>
    </template>
  </layout>
</template>
<script>
import Layout from "@/views/Layout";
import {post} from "@/utils/api";
import SmartPicker from "@/components/commons/SmartPicker.vue";
import clipboard from "@/utils/clipboard";

export default {
  name: 'HlStats',
  components: {SmartPicker, Layout},
  data() {
    return {
      headers: [
        {text: "Région", value: "regionName",},
        {text: "Agences actives", value: "nbActiveAgencies", align: "right"},
        {text: "Agences", value: "nbAgencies", align: "right"},
        {text: "Agents", value: "nbAgents", align: "right"},
        {text: "Bookings", value: "nbBookings", align: "right"},
        {text: "CA", value: "totalRevenue", align: "right"},
        {text: "", value: "actions", sortable: false, width: "40px"},
      ],
      loading: false,
      ctx: null,
      defaultCtx: {
        startDateAct: this._formatDate(new Date().setFullYear(new Date().getFullYear() - 1), "dd/MM/yyyy"),
        stopDateAct: this._nowFormatted("dd/MM/yyyy"),
        startDateOld: null,
        stopDateOld: null,
        destinations: [],
        sites: ['HLagons'],
        commercialIds: [],
        allAgencies: true
      },
      data: {noFlights: [], withFlights: [], total: []}
    }
  },
  created() {
    this.ctx = this.defaultCtx
    this.search()
  },
  methods: {
    search() {
      this.data = {noFlights: [], withFlights: [], total: []}
      this.loading = true
      const searchForm = {
        ...this.ctx,
        startDateOld: this._formatDate(this._subYears(this._parseDate(this.ctx.startDateAct, "dd/MM/yyyy"), 1), 'yyyy-MM-dd'),
        stopDateOld: this._formatDate(this._subYears(this._parseDate(this.ctx.stopDateAct, "dd/MM/yyyy"), 1), 'yyyy-MM-dd'),
        startDateAct: this._parseAndFormatDate(this.ctx.startDateAct, "dd/MM/yyyy", "yyyy-MM-dd"),
        stopDateAct: this._parseAndFormatDate(this.ctx.stopDateAct, "dd/MM/yyyy", "yyyy-MM-dd"),

      }

      post("/api/widget/agency-stats/regions", searchForm).json(rs => {
        ['act', 'actWithFlights'].forEach(str => {
          const oldStr = str == 'act' ? 'old' : 'oldWithFlights'
          const obj = rs[str].map(act => {
            const oldObj = rs[oldStr].find(old => old.regionName == act.regionName)
            return {
              ...act,
              nbActiveAgencies: {act: act.nbActiveAgencies, old: oldObj.nbActiveAgencies},
              nbAgencies: {act: act.nbAgencies, old: null},
              nbAgents: {act: act.nbAgents, old: null},
              nbBookings: {act: act.nbBookings, old: oldObj.nbBookings},
              totalRevenue: {act: act.totalRevenue, old: oldObj.totalRevenue},
            }
          })


          this.data[str == 'act' ? 'noFlights' : 'withFlights'].push(...obj)

        })

      }).then(() => {
        this.data.noFlights.forEach(noFlight => {
          const withFlight = this.data.withFlights.find(data => data.regionName == noFlight.regionName)
          const total = {
            ...noFlight,
            nbActiveAgencies: {
              act: noFlight.nbActiveAgencies.act + withFlight.nbActiveAgencies.act,
              old: noFlight.nbActiveAgencies.old + withFlight.nbActiveAgencies.old
            },
            nbAgencies: {act: noFlight.nbAgencies.act, old: null},
            nbAgents: {act: noFlight.nbAgents.act, old: null},
            nbBookings: {
              act: noFlight.nbBookings.act + withFlight.nbBookings.act,
              old: noFlight.nbBookings.old + withFlight.nbBookings.old
            },
            totalRevenue: {
              act: noFlight.totalRevenue.act + withFlight.totalRevenue.act,
              old: noFlight.totalRevenue.old + withFlight.totalRevenue.old
            },
          }
          this.data.total.push(total)
        })
        this.totalTable(this.data.noFlights)
        this.totalTable(this.data.withFlights)
        this.totalTable(this.data.total)


      })

      this.loading = false
    },
    copyTotal() {
      this.copy(this.data.total)
    },
    copyNoFlight() {
      this.copy(this.data.noFlights)
    },
    copyWithFlight() {
      this.copy(this.data.withFlights)
    },
    copy(datas) {
      const separator = "\t";
      const tmpHeaders = this.headers.map(h => h.text + separator)

      tmpHeaders.splice(6, 0, `CA n-1${separator}`)
      tmpHeaders.splice(5, 0, `Dossiers n-1${separator}`)
      tmpHeaders.splice(2, 0, `Agences actives n-1${separator}`)

      const headers = tmpHeaders.join(" ");

      const rows = datas.map((i) => {
        const rowObj =
            {
              regionName: i.regionName,
              nbActiveAgencies: i.nbActiveAgencies.act,
              oldActiveAgencies: i.nbActiveAgencies.old ?? 0,
              nbAgencies: i.nbAgencies.act,
              nbAgents: i.nbAgents.act,
              nbBookings: i.nbBookings.act,
              oldNbBooking: i.nbBookings.old ?? 0,
              totalRevenue: i.totalRevenue.act,
              oldRevenu: i.totalRevenue.old ?? 0
            }

        return `${Object.values(rowObj).join(separator)}`;
      });

      const allRows = [headers].concat(rows);
      clipboard.copyTextToClipboard(allRows.join("\n"));
    },

    totalTable(dataTable) {
      const global = dataTable.reduce((acc, curr) => {
            acc.nbActiveAgencies.act += curr.nbActiveAgencies.act
            acc.nbActiveAgencies.old += curr.nbActiveAgencies.old
            acc.nbAgencies = curr.nbAgencies
            acc.nbAgents = curr.nbAgents
            acc.nbBookings.act += curr.nbBookings.act
            acc.nbBookings.old += curr.nbBookings.old
            acc.totalRevenue.act += curr.totalRevenue.act
            acc.totalRevenue.old += curr.totalRevenue.old
            return acc
          },
          {
            regionName:"Total",
            nbActiveAgencies: {act: 0, old: 0},
            nbAgencies: 0,
            nbAgents: 0,
            nbBookings: {act: 0, old: 0},
            totalRevenue: {act: 0, old: 0},
          }
      )
      dataTable.push(global)
    }
  },
  clearSearchform() {
    this.ctx = this.defaultCtx
  }
  ,
}
</script>
